<template>
  <div v-if="OrderForms">
    <el-table :data="OrderForms">
      <el-table-column prop="date1" label="日期"style="width: 4%;":formatter="formatDate"></el-table-column>
      <el-table-column prop="name" label="姓名" style="width: 3%;"></el-table-column>
      <el-table-column prop="sex" label="性别" style="width: 3%;"></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        style="width: 4%;"
      ></el-table-column>
      <el-table-column
        prop="idc"
        label="身份证号"
        style="width: 5%;"
      ></el-table-column>
      <el-table-column
        prop="units"
        label="来访单位"
        style="width: 5%;"
      ></el-table-column>
      <el-table-column
        prop="text"
        label="来访事由"
        style="width: 5%;"
      ></el-table-column>
      <el-table-column
        prop="car"
        label="车牌号码"
        style="width: 4%;"
      ></el-table-column>
      
      <el-table-column fixed="right" label="操作" style="width: 10%;">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row._id)" type="text" size="small"
            >编辑</el-button
          >
          <el-button @click="remove(scope.row._id)" type="text" size="small"
            >删除</el-button>
         
        </template>
      </el-table-column>
    </el-table>
    <div >
      <footers/>
    </div>
  </div>
</template>

<script>
import footers from '../components/footer.vue'

export default {
  components: {
    footers
  },
  data() {
    return {
      OrderForms: [],
    };
  },
  methods: {
    fetchOrderForms() {
      this.$http
        .get("OrderForm")
        .then((res) => {
          this.OrderForms = res;
        })
        .catch((err) => {
          console.error("获取人员列表失败:", err);
        });
    },
    edit(id) {
      this.$router.push(`/order/${id}/edit`);
    },
    remove(id) {
      this.$http
        .delete(`OrderForm/${id}`)
        .then((res) => {
          this.$message({
            message: "人员删除成功",
            type: "success",
          });
          this.fetchOrderForms();
        })
        .catch((error) => {
          console.error("删除人员失败:", error);
          this.$message.error("人员删除失败，请重试");
        });
    },
    formatDate(row, column, cellValue) {
      const date = new Date(cellValue);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

  },
  created() {
    this.fetchOrderForms();
  },
};
</script>
